module.exports = __webpack_public_path__ + "static/media/editea_plugin_host_url.5bfb9b90.png";